import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { BookmarksProvider } from "@/lib/bookmarks";
import { GeoProvider } from "@/lib/geo";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import RequireAuth from "@/components/RequireAuth";
import AIChatWidget from "@/components/AIChatWidget";
import Home from "@/pages/Home";
import Search from "@/pages/Search";
import Listing from "@/pages/Listing";
import AddBusiness from "@/pages/AddBusiness";
import ClaimBusiness from "@/pages/ClaimBusiness";
import ForBusinesses from "@/pages/ForBusinesses";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import BusinessDashboard from "@/pages/BusinessDashboard";
import UserDashboard from "@/pages/UserDashboard";
import AdminPanel from "@/pages/AdminPanel";
import StatePage from "@/pages/StatePage";
import CityPage from "@/pages/CityPage";
import ServiceCityPage from "@/pages/ServiceCityPage";
import ComparePage from "@/pages/ComparePage";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import ReviewRequestRedirect from "@/pages/ReviewRequestRedirect";

// Legacy city URL → permanent client-side redirect to canonical /cities/:state/:city/iv-therapy.
// Combined with the canonical link on CityPage, this prevents duplicate-content competition.
function LegacyCityRedirect() {
  const { state, city } = useParams();
  return <Navigate to={`/cities/${state}/${city}/iv-therapy`} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BookmarksProvider>
        <GeoProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/search" element={<Layout><Search /></Layout>} />
          <Route path="/listing/:slug" element={<Layout><Listing /></Layout>} />
          {/* Canonical location URL (mirrors /listing/:slug for backward compatibility) */}
          <Route path="/location/:slug" element={<Layout><Listing /></Layout>} />
          <Route path="/for-businesses" element={<Layout><ForBusinesses /></Layout>} />
          <Route path="/compare" element={<Layout><ComparePage /></Layout>} />

          {/* Blog */}
          <Route path="/blog" element={<Layout><BlogList /></Layout>} />
          <Route path="/blog/:slug" element={<Layout><BlogPost /></Layout>} />

          {/* Review-request landing (from SendGrid emails) */}
          <Route path="/r/:token" element={<ReviewRequestRedirect />} />

          {/* SEO */}
          <Route path="/iv-therapy/:state" element={<Layout><StatePage /></Layout>} />
          <Route path="/iv-therapy/:state/:city" element={<LegacyCityRedirect />} />
          <Route path="/cities/:state/:city/iv-therapy" element={<Layout><CityPage /></Layout>} />
          <Route path="/:service/:city" element={<Layout><ServiceCityPage /></Layout>} />

          <Route path="/add-business" element={<RequireAuth><Layout><AddBusiness /></Layout></RequireAuth>} />
          <Route path="/claim-business" element={<RequireAuth><Layout><ClaimBusiness /></Layout></RequireAuth>} />
          <Route path="/dashboard/user" element={<RequireAuth><Layout><UserDashboard /></Layout></RequireAuth>} />
          <Route path="/dashboard/business/*" element={<RequireAuth><Layout><BusinessDashboard /></Layout></RequireAuth>} />
          <Route path="/admin" element={<RequireAuth role="admin"><Layout><AdminPanel /></Layout></RequireAuth>} />
        </Routes>
        <AIChatWidget />
      </BrowserRouter>
        </GeoProvider>
      </BookmarksProvider>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
